// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
// MODIFICA: Ri-aggiunto import di 'auth' per poter fare il signOut
import { auth } from './firebase'; 

// 1. IMPORTA L'AUTH PROVIDER E L'HOOK
import { AuthProvider, useAuth } from './context/AuthContext';

// Importazione dei componenti delle pagine
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import UsersPage from './pages/UsersPage';
import BookingsPage from './pages/BookingsPage';
import CertificatesPage from './pages/CertificatesPage';
import ClosurePage from './pages/ClosurePage';
import UserDetail from './pages/UserDetail';
import MainLayout from './components/MainLayout';
import NewUserForm from './pages/NewUserForm';
import GymActivitiesScreen from './pages/GymActivitiesScreen';

// 2. RIDEFINIAMO IL PROTECTEDROUTE PER USARE IL CONTEXT
function ProtectedAdminRoute({ children }) {
  const { currentUser, isAdmin } = useAuth(); // Dati dal Context

  if (!currentUser) {
    // 1. Non loggato -> vai al login
    return <Navigate to="/login" replace />;
  }
  
  if (!isAdmin) {
    // 2. Loggato ma NON admin ->
    
    // --- MODIFICA CHIAVE ---
    // Forziamo il logout prima di reindirizzare.
    // Questo previene che l'utente resti "loggato" ma bloccato
    // sulla pagina di login.
    auth.signOut();
    // --------------------

    // Rimandato al login CON MESSAGGIO
    return <Navigate 
             to="/login" 
             replace 
             state={{ error: "Accesso negato. Solo gli amministratori possono accedere." }} 
           />; 
  }

  // 3. Loggato E admin -> mostra la pagina richiesta (children)
  return children;
}

// 3. SPOSTIAMO LE ROTTE IN UN COMPONENTE INTERNO
// Questo è necessario perché deve essere "figlio" di AuthProvider
// per poter usare l'hook useAuth()
function AppRoutes() {
  const { currentUser } = useAuth();

  return (
    <BrowserRouter>
      <CssBaseline />
      <Routes>
        {/* La rotta Login ora usa il currentUser dal context
            Se l'utente è loggato (currentUser esiste), naviga a "/"
            Se non è loggato, mostra <Login />
        */}
        <Route 
          path="/login" 
          element={currentUser ? <Navigate to="/" replace /> : <Login />} 
        />

        {/* 4. USIAMO IL NUOVO ProtectedAdminRoute per / e tutti i figli */}
        <Route
          path="/"
          element={
            <ProtectedAdminRoute>
              <MainLayout />
            </ProtectedAdminRoute>
          }
        >
          {/* Rotta della Dashboard (home) */}
          <Route index element={<Dashboard />} /> 
          
          {/* Rotta per la gestione degli utenti */}
          <Route path="users">
            <Route index element={<UsersPage />} />
            <Route path="new" element={<NewUserForm />} />
            <Route path=":userId" element={<UserDetail />} />
          </Route>
          
          {/* Le altre rotte */}
          <Route path="bookings" element={<BookingsPage />} />
          <Route path="activities" element={<GymActivitiesScreen />} />
          <Route path="certificates" element={<CertificatesPage />} />
          <Route path="closure" element={<ClosurePage />} />
        </Route>

        <Route path="*" element={<h1>404 - Pagina non trovata</h1>} />
      </Routes>
    </BrowserRouter>
  );
}

// 5. IL COMPONENTE APP ORA È SOLO IL CONTENITORE
export default function App() {
  // Tutto lo stato e la logica di auth sono ora
  // gestiti da AuthProvider.
  // AuthProvider mostrerà lo spinner (definito in AuthContext.js)
  // finché il caricamento (auth + check admin) non è finito.
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}